class MemStore {
    constructor() {
        this.store = {};
    }
    getItem(key) {
        var _a;
        return (_a = this.store[key]) !== null && _a !== void 0 ? _a : null;
    }
    setItem(key, value) {
        this.store[key] = value;
    }
    removeItem(key) {
        delete this.store[key];
    }
    clear() {
        this.store = {};
    }
    key(index) {
        return Object.keys(this.store)[index];
    }
    get length() {
        return Object.keys(this.store).length;
    }
}
export function isSupported(storage) {
    try {
        const key = Math.random().toString(36);
        storage.setItem(key, key);
        storage.removeItem(key);
        return true;
    }
    catch (_a) {
        return false;
    }
}
let isLocalStoreSupported = false;
try {
    isLocalStoreSupported = isSupported(localStorage);
}
catch (e) { }
export const localStore = isLocalStoreSupported ? localStorage : new MemStore();
let isSessionStoreSupported = false;
try {
    isSessionStoreSupported = isSupported(sessionStorage);
}
catch (e) { }
export const sessionStore = isSessionStoreSupported
    ? sessionStorage
    : new MemStore();
